/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCurrencyYuan = createReactComponent("currency-yuan", "IconCurrencyYuan", [
  ["path", { d: "M12 19v-7l-5 -7", key: "svg-0" }],
  ["path", { d: "M17 5l-5 7", key: "svg-1" }],
  ["path", { d: "M8 13h8", key: "svg-2" }]
]);

export { IconCurrencyYuan as default };
//# sourceMappingURL=IconCurrencyYuan.js.map
